import React, {useState} from "react";
import {Box, Button, Checkbox, FormControlLabel} from "@mui/material";
import styles from "../../assets/styles/modules/Terms.module.css";
import logo from "../../assets/images/newssum_logo.svg";
import Checked from "../../assets/images/icon_terms_check_checked.svg";
import Unchecked from "../../assets/images/icon_terms_check_unchecked.svg";

const Terms = () => {
    const [allTerms, setAllTerms] = useState(false);
    const [firstTerm, setFirstTerm] = useState(false);
    const [firstTermHelper, setFirstTermHelper] = useState(false); // 첫번째 약관 동의 경고
    const [secondTerm, setSecondTerm] = useState(false);
    const [secondTermHelper, setSecondTermHelper] = useState(false);  // 첫번째 약관 동의 경고

    const funcSetAllTerms = () => {
        switch (allTerms) {
            case true:
                setAllTerms(false);
                setFirstTerm(false);
                setSecondTerm(false);
                break;
            case false:
                setAllTerms(true);
                setFirstTerm(true);
                setFirstTermHelper(false);
                setSecondTerm(true);
                setSecondTermHelper(false);
                break;
        }
    }

    const funcSetFirstTerm = () => {
        switch (firstTerm) {
            case true:
                switch (allTerms) {
                    case true:
                        setAllTerms(false);
                        setFirstTerm(false);
                        break;
                    case false:
                        setFirstTerm(false);
                        break;
                }
                break;
            case false:
                switch (secondTerm) {
                    case true:
                        setAllTerms(true);
                        setFirstTerm(true);
                        setFirstTermHelper(false);
                        break;
                    case false:
                        setFirstTerm(true);
                        setFirstTermHelper(false);
                        break;
                }
                break;
        }
    }

    const funcSetSecondTerm = () => {
        switch (secondTerm) {
            case true:
                switch (allTerms) {
                    case true:
                        setAllTerms(false);
                        setSecondTerm(false);
                        break;
                    case false:
                        setSecondTerm(false);
                        break;
                }
                break;
            case false:
                switch (firstTerm) {
                    case true:
                        setAllTerms(true);
                        setSecondTerm(true);
                        setSecondTermHelper(false);
                        break;
                    case false:
                        setSecondTerm(true);
                        setSecondTermHelper(false);
                        break;
                }
                break;
        }
    }

    const goToJoin = () => {
        if (firstTerm === false) {
            setFirstTermHelper(true);
        }
        if (secondTerm === false) {
            setSecondTermHelper(true);
        }
        if ((firstTerm && secondTerm) === true) {
            window.location.replace('/join')
        }
    }

    return (
        <div className={styles.container}>
            <img src={logo} className={styles.logo} alt="투디지트 로고"/>
            <div className={styles.term_container}>
                <FormControlLabel
                    control={<Checkbox size="large" checked={allTerms} icon={<img src={Unchecked} alt='체크박스'/>} checkedIcon={<img src={Checked} alt='체크박스'/>} onClick={funcSetAllTerms}/>}
                    label="전체 약관에 동의합니다."
                />
            </div>
            <div className={styles.term_container}>
                <div className={styles.term_checkbox}>
                    <FormControlLabel
                        control={<Checkbox size="large" checked={firstTerm} icon={<img src={Unchecked} alt='체크박스'/>} checkedIcon={<img src={Checked} alt='체크박스'/>} onClick={funcSetFirstTerm}/>}
                        label="서비스 이용약관 동의"
                        sx={{marginRight: '4px'}}
                    />
                    <span className={styles.required}>필수</span>
                </div>
                <Box component="div" className={styles.term_contents} sx={{padding: "20px", overflowY: "scroll"}}>
                  <span className={styles.termTextTitle}>이용약관<br/></span>
                    이 약관에서 사용하는 용어의 정의는 다음 각호와 같으며, 정의되지 않은
                    용어에 대한 해석은 관계법령 및 서비스별 안내에서 정하는 바에 따릅니다.
                    1)서비스 : 이용 고객 또는 회원이 PC, TV, 휴대형 단말기 등 각종 유무선
                    기기 또는 프로그램을 통하여 이용할 수 있도록 회사가 제공하는 모든
                    인터넷 서비스를 말하며, 회사가 공개한 ApI를 이용하여 제3자가 개발 또는
                    구축한 프로그램이나 서비스를 통하여 이용 고객 또는 회원에게 제공되는
                    경우를 포함합니다. 2)회원 : 이 약관에 동의하고 회사와 이용 계약을
                    체결하여, 회사가 제공하는 서비스를 사용하는 자를 말합니다. 3)이용고객
                    : 회사의 서비스를 이용하기 위하여 회사와 이용계약을 체결하려고 하는
                    자를 말합니다. 4)회원정보 : 회사가 이용고객에게 회원가입 신청양식(이하
                    “신청양식”이라 합니다)에 기재를 요청하는 이용고객의 개인정보를
                    말합니다. 5)ID(고유번호) : 회원의 식별과 회원의 서비스 이용을 위하여
                    사용되는 식별 정보를 말합니다. 6)비밀번호 : 회원의 회원정보 보호를
                    위해 회원 자신이 설정한 문자와 숫자의 조합을 말합니다.{" "}
                </Box>
                <div className={styles.term_helper}>
                    {firstTermHelper ? <>모든 약관에 동의해주세요.</> : <></>}
                </div>
            </div>
            <div className={styles.term_container}>
                <div className={styles.term_checkbox}>
                    <FormControlLabel
                        control={<Checkbox size="large" checked={secondTerm} icon={<img src={Unchecked} alt='체크박스'/>} checkedIcon={<img src={Checked} alt='체크박스'/>} onClick={funcSetSecondTerm}/>}
                        label="서비스 이용약관 동의"
                        sx={{marginRight: '4px'}}
                    />
                    <span className={styles.required}>필수</span>
                </div>
                <Box component="div" className={styles.term_contents} sx={{padding: "20px", overflowY: "scroll"}}>
                    이 약관에서 사용하는 용어의 정의는 다음 각호와 같으며, 정의되지 않은
                    용어에 대한 해석은 관계법령 및 서비스별 안내에서 정하는 바에 따릅니다.
                    1)서비스 : 이용 고객 또는 회원이 PC, TV, 휴대형 단말기 등 각종 유무선
                    기기 또는 프로그램을 통하여 이용할 수 있도록 회사가 제공하는 모든
                    인터넷 서비스를 말하며, 회사가 공개한 ApI를 이용하여 제3자가 개발 또는
                    구축한 프로그램이나 서비스를 통하여 이용 고객 또는 회원에게 제공되는
                    경우를 포함합니다. 2)회원 : 이 약관에 동의하고 회사와 이용 계약을
                    체결하여, 회사가 제공하는 서비스를 사용하는 자를 말합니다. 3)이용고객
                    : 회사의 서비스를 이용하기 위하여 회사와 이용계약을 체결하려고 하는
                    자를 말합니다. 4)회원정보 : 회사가 이용고객에게 회원가입 신청양식(이하
                    “신청양식”이라 합니다)에 기재를 요청하는 이용고객의 개인정보를
                    말합니다. 5)ID(고유번호) : 회원의 식별과 회원의 서비스 이용을 위하여
                    사용되는 식별 정보를 말합니다. 6)비밀번호 : 회원의 회원정보 보호를
                    위해 회원 자신이 설정한 문자와 숫자의 조합을 말합니다.{" "}
                </Box>
                <div className={styles.term_helper}>
                    {secondTermHelper ? <>모든 약관에 동의해주세요.</> : <></>}
                </div>
            </div>
            <div className={styles.term_container}>
                <Button id={styles.join_btn} variant="text" onClick={goToJoin}>
                    가입하기
                </Button>
            </div>
        </div>
    );
};

export default Terms;
